import { ActivityCodesFilter } from 'components/common/GlobalFilterComponent/components/ActivityCodesFilter/ActivityCodesFilter';
import { ActivityTypeFilter } from 'components/common/GlobalFilterComponent/components/ActivityTypeFilter/activityTypeFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { ProgramTagsFilter } from 'components/common/GlobalFilterComponent/components/ProgramTagsFilter/programTagsFilter';
import { ResourceFilter } from 'components/common/GlobalFilterComponent/components/ResourceFilter/resourceFilter';
import { TagsFilter } from 'components/common/GlobalFilterComponent/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';
import { DateRangeFilter } from 'components/common/GlobalFilterComponent/components/dateRangeFilter/dateRangeFilter';
import { ProductivityPreDefinedFilter } from 'components/common/GlobalFilterComponent/components/productivityPreDefinedFilter/productivityPreDefinedFilter';
import { ProgressMeasurementFilter } from 'components/common/GlobalFilterComponent/components/progressMeasurementFilter/progressMeasurementFilter';
import { QuickAnswerFilter } from 'components/common/GlobalFilterComponent/components/quickAnswerFilter/quickAnswerFilter';
import { ResourceTypeFilter } from 'components/common/GlobalFilterComponent/components/resourceTypeFilter/resourceTypeFilter';

export type GlobalFiltersRegistryKey =
    | 'milestoneFragnet'
    | 'tags'
    | 'wbs'
    | 'activityCodes'
    | 'progressMeasurement'
    | 'resourceType'
    | 'dateRangeFilter'
    | 'productivityPreDefined'
    | 'activityType'
    | 'resource'
    | 'quickAnswerFilter'
    | 'programTags';

export const globalFiltersRegistry: Record<GlobalFiltersRegistryKey, React.ComponentType<any>> = {
    milestoneFragnet: MilestoneFragnetFilter,
    tags: TagsFilter,
    wbs: WbsFilter,
    activityCodes: ActivityCodesFilter,
    progressMeasurement: ProgressMeasurementFilter,
    resourceType: ResourceTypeFilter,
    resource: ResourceFilter,
    dateRangeFilter: DateRangeFilter,
    productivityPreDefined: ProductivityPreDefinedFilter,
    activityType: ActivityTypeFilter,
    programTags: ProgramTagsFilter,
    quickAnswerFilter: QuickAnswerFilter,
};
